<template>
  <div class="invite-team-player-list" >
    <div class="title" >
      <h3>选择参赛球员</h3>
      <p>若需要编辑的参赛球员资料太多，你可以点击“邀请队员编辑个人资料”分享个人资料编辑页面到球队群让队员自行编辑</p>
    </div>
    <div class="add" >
      <div>0<i>/{{playerList.length}}</i></div>
      <span @click="routerAddPlayer" >添加</span>
    </div>
    <van-checkbox-group v-model="result">
      <van-cell-group class="checkbox">
        <van-cell v-for="(item) in playerList" :key="item.id" clickable>
          <div class="player">
            <div>
              <img v-if="item.avatar" :src="formatterImgSrc(item.avatar)" >
              <img v-else src="@/assets/images/player-logo-empty.png" />
            </div>
            <div>
              <p>{{item.nickName}}</p>
              <span>{{item.position}} {{item.number}}号</span>
            </div>
          </div>
          <van-checkbox :name="item.id" />
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>
    <div style="width: 100%; height: 100px;" ></div>
    <div class="foot" >
      <van-button type="primary" size="large" @click="createBMPlayerByUser">确认</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { getBMTeamUserList, createBMPlayerByUser, getBMTeamPlayerList } from '@/api/team'
import { ImageFormat } from '@/utils/'
import { Toast } from 'vant'

Vue.use(Toast)

export default {
  name: 'playerList',
  data() {
    return {
      query: this.$route.query,
      teamId: '',
      matchId: '',
      playerList: [],
      existList: [],
      result: []
    }
  },
  created() {
    this.teamId = this.query.teamId
    this.matchId = this.query.matchId
    if (!this.teamId || !this.matchId) {
      Toast('参赛错误')
    }
    this.getBMTeamPlayerList()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  methods: {
    routerAddPlayer() {
      this.$router.push({name: 'PlayerEdit',
        query: {matchId: this.matchId, teamId: this.teamId, type: 'captain'}})
    },
    routerEditPlayer(playerId) {
      this.$router.push({name: 'PlayerEdit',
        query: {matchId: this.matchId, teamId: this.teamId, playerId: playerId, type: 'captain'}})
    },
    getBMTeamUserList() {
      const params = {
        teamId: this.teamId,
        pageSize: 9999
      }
      getBMTeamUserList(params).then(response => {
        const data = response.data
        data.players.filter((item, index) => {
          this.existList.filter(exis => {
            if (item.id === exis.userId) {
              data.players.splice(index, 1)
            }
          })
        })
        this.playerList = data.players
      })
    },
    createBMPlayerByUser() {
      const params = {
        teamId: this.teamId,
        matchId: this.matchId,
        userIds: this.result.join()
      }
      createBMPlayerByUser(params).then(response => {
        const data = response.data
        if (data) {
          Toast('添加参赛球员成功')
          this.$router.go(-1)
        }
      })
    },
    getBMTeamPlayerList() {
      let params = {
        teamId: this.teamId,
        matchId: this.matchId
      }
      getBMTeamPlayerList(params).then(response => {
        const data = response.data
        this.team = data.team
        this.existList = data.players
        this.getBMTeamUserList()
      })
    }
  }
}
</script>

<style lang="stylus" >
.invite-team-player-list
  background-color white
  .title
    padding 15px
    padding-bottom 0
    h3
      font-size: 30px;
      font-weight: 400;
      color: rgba(0,0,0,1);
      margin: 0;
    p
      font-size:16px;
      font-weight:300;
      color:rgba(74,74,74,1);
      line-height:22px;
  .add
    font-size:18px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(0,0,0,1);
    padding: 10px 15px;
    div:first-child
        font-size:18px;
        font-weight:400;
        color:rgba(0,0,0,1);
        display inline
      i
        font-style: normal
        font-size 14px
    span
      border-radius:14px;
      border:1px solid rgba(242,242,242,1);
      float: right
      font-size:12px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(155,155,155,1);
      padding: 3px 13px;
  .player
    display flex
    padding 15px
    width 100%
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
        border-radius: 50%;
    div:last-child
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
  .checkbox
    .van-cell
      padding: 0
      .van-cell__value
        display flex
        justify-content: space-between
        align-items: center
        .van-checkbox
          padding-right 15px
          align-items: center
  .foot
    position fixed
    bottom 0
    width 100%
    .van-button
      border none
      font-size:16px;
      font-weight normal
      color: #32A377;
      line-height:25px;
    .van-button--primary
      background-color #FAFAFA
      font-size:20px;
      font-weight:400;
</style>



// WEBPACK FOOTER //
// src/pages/invite-team/captain/player-list.vue